export const postCountIsUpToDate = Symbol('postCountIsUpToDate')
export const postChildCountIsUpToDate = Symbol('postChildCountIsUpToDate')
export const articleCountIsUpToDate = Symbol('postChildCountIsUpToDate')
export const articleChildCountIsUpToDate = Symbol('postChildCountIsUpToDate')
